
const settings = {
  // Settings
  settings: {
    accountSettings: "Account Settings",
    accountSettingsDescription: "Manage your account settings and preferences",
    profile: "Profile",
    security: "Security",
    notifications: "Notifications",
    payment: "Payment",
    personalInformation: "Personal Information",
    personalInfoDescription: "Update your personal details and contact information",
    changePassword: "Change Password",
    passwordSecurityDescription: "Ensure your account stays secure with a strong password",
    currentPassword: "Current Password",
    newPassword: "New Password",
    confirmPassword: "Confirm Password",
    updatePassword: "Update Password",
    accountSecurity: "Account Security",
    accountSecurityDescription: "Additional security features for your account",
    twoFactorAuth: "Two-Factor Authentication",
    twoFactorAuthDescription: "Add an extra layer of security to your account",
    setup: "Setup",
    loginHistory: "Login History",
    loginHistoryDescription: "View your recent login activity",
    view: "View",
    emailNotifications: "Email Notifications",
    emailNotificationsDescription: "Choose which email notifications you'd like to receive",
    marketingEmails: "Marketing Emails",
    marketingEmailsDescription: "Receive updates about new features and promotions",
    surveysAndFeedback: "Surveys and Feedback",
    surveysAndFeedbackDescription: "Help us improve by participating in surveys",
    appNotifications: "App Notifications",
    appNotificationsDescription: "Receive notifications about predictions and matches",
    enabled: "Enabled",
    disabled: "Disabled",
    billingHistory: "Billing History",
    billingHistoryDescription: "View your past invoices and payment history",
    premiumSubscription: "Premium Subscription",
    viewInvoice: "View Invoice",
    subscription: "Subscription",
    subscriptionDescription: "Manage your subscription and billing details",
    currentPlan: "Current Plan",
    subscriptionRenews: "Your subscription renews automatically on the 1st of each month",
    cancelSubscription: "Cancel Subscription",
    upgradePlan: "Upgrade Plan",
    fillRequiredFields: "Please fill in all required fields",
    invalidEmail: "Please enter a valid email address",
    profileUpdated: "Profile updated successfully",
    updateError: "Failed to update. Please try again.",
    enterCurrentPassword: "Please enter your current password",
    passwordRequirements: "Password must be at least 8 characters long",
    passwordsDoNotMatch: "Passwords do not match",
    passwordUpdated: "Password updated successfully",
    pleaseLogin: "Please log in to access account settings",
    notificationSettingsUpdated: "Notification settings updated successfully"
  }
};

export default settings;
